
    import {PageRequest} from '@/store/shared/entity'
    import CreateTenant from './component/create-tenant.vue'
    import EditTenant from './component/edit-tenant.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";
    
    class PageTenantRequest extends PageRequest{
        name:string;
    }
    
    @Component({components:{CreateTenant,EditTenant}})
    export default class Tenants extends Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageTenantRequest(),
            queryAction:"system/tenant/getAll",
            isAutoQuery: true,
            cols:[{
                title:this.L('Tenants.TenancyName'),
                key:'tenancyName'
            },{
                title:this.L('Tenants.Name'),
                key:'name'
            },this.$util.render.actions(this.colButtons)]
        }

        reset(){
            this.data.model = new PageTenantRequest();
        }

        colButtonCheck = (row) => {
            return row.tenancyName !== "Default";
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                this.colEditBtnM(row => this.colButtonCheck(row)),
                this.colDeleteBtn(row => this.colButtonCheck(row))
            ]
        }
    }
